import { FormattedIdwProfileProperty, IdwProfileProperty } from "@idw-types/data/idw-profile";
import { AvailableProperty } from "@idw-types/data/reference-data/axn";

export const formatAppliedProfileProfileProperties = (
    profileProperties: Array<IdwProfileProperty>,
    availableProperties: Array<AvailableProperty>
): Array<FormattedIdwProfileProperty> => {
    return availableProperties.map(availableProperty => formatAppliedProfileProfileProperty(
        availableProperty,
        profileProperties
    ));
};

export const formatAppliedProfileProfileProperty = (
    availableProperty: AvailableProperty,
    profileProperties: Array<IdwProfileProperty>,
): FormattedIdwProfileProperty => {
    const profileProperty = profileProperties.find(pp => pp.availablePropertyID === availableProperty.id);

    return {
        id: profileProperty?.id,
        value: profileProperty?.value,
        availableProperty: availableProperty,
        addedToProfile: !!profileProperty
    };
};